import React from 'react'
import FullscreenToggle from './headerComponents/FullscreenToggle';
import ProfileDropdown from './headerComponents/ProfileDropdown';

const Header = () => {

  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">

          </div>
          <div className="d-flex align-items-center">
            <div className="dropdown d-md-none topbar-head-dropdown header-item"></div>
            <div className="dropdown d-md-none topbar-head-dropdown header-item"></div>
            <div className="dropdown d-md-none topbar-head-dropdown header-item"></div>
            <div className="dropdown d-md-none topbar-head-dropdown header-item"></div>
            <div className="ms-1 header-item d-none d-sm-flex"></div>
            <div className="ms-1 header-item d-none d-sm-flex"></div>
            <div className="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown"></div>
            <FullscreenToggle />
            <ProfileDropdown />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header